// extracted by extract-css-chunks-webpack-plugin
module.exports = {"warning":"#f8d13a","greyLight":"#b5b5b5"};